import template from "./change-organization-modal.html";

const ChangeOrganizationModalComponent = {
  bindings: {
    dismiss: "&",
  },
  template: template,
  controller: class ChangeOrganizationModalController {
    /* @ngInject */
    constructor($state, $rootScope, User, SecurityManager) {
      this.$rootScope = $rootScope;
      this.$state = $state;
      this.User = User;
      this.SecurityManager = SecurityManager;
    }

    $onInit() {
      this.initValues();
    }

    async initValues() {
      this.loading = true;
      await this.SecurityManager.refreshUser();
      this.user = this.$rootScope.user;
      this.organizations = this.$rootScope.user.organizations;

      this.currentOrganization = this.$rootScope.organization;
      this.defaultOrganization = this.$rootScope.user.defaultOrganization;
      this.loading = false;
      this.$rootScope.$applyAsync();
    }

    async updateDefaultOrganization(defaultOrganization) {
      this.loading = true;
      await this.User.updateDefaultOrganization(defaultOrganization.id);
      await this.SecurityManager.refreshUser();
      this.initValues();
      this.loading = false;
      this.$rootScope.$applyAsync();
    }

    goCreateOrganization() {
      this.$state.go("createOrganizations");
    }

    isCurrentOrganization(organization) {
      return organization.id === this.currentOrganization.id;
    }

    isDefaultOrganization(organization) {
      return organization.id === this.defaultOrganization.id;
    }

    cancel() {
      this.dismiss({ $value: "cancel" });
    }
  },
};

export default ChangeOrganizationModalComponent;
